import { render } from "./SkeletonCard.vue?vue&type=template&id=6139967a&scoped=true&ts=true"
import script from "./SkeletonCard.vue?vue&type=script&lang=ts"
export * from "./SkeletonCard.vue?vue&type=script&lang=ts"

import "./SkeletonCard.vue?vue&type=style&index=0&id=6139967a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6139967a"]])

export default __exports__